import en from './account.i18n.json';

export const account = { en };
